import { 
	GET_WORKSHOPS, 
	GET_WORKSHOP,
	CREATE_WORKSHOP,
	UPDATE_WORKSHOP,
	DESTROY_WORKSHOP,
} from "./actions"

export function WorkshopsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_WORKSHOPS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_WORKSHOP}_FULFILLED`:
		case `${CREATE_WORKSHOP}_FULFILLED`:
		case `${UPDATE_WORKSHOP}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_WORKSHOP}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { WorkshopsReducer } from "modules/workshops/reducer"

// workshops:WorkshopsReducer,
